import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// import { getVideoCat } from "@/util/data.js";
export default new Vuex.Store({
  state: {
    initState: 0,
    userInfo: {},
    toast: false,
    toastContent: "",
    time: 1000,
    topicId: '',
    num: 0,
    showForm: -1,
    login: false,
    token: "",
    showRole: false,
    userDetail: "",
    times: 0,
    viewNum: 0,
    showShare: false,
    videoCates: [],
    showFloatNav: true,
    showJoin: -1,
    showNick: false,
    isMobile: false,
    domHeight: 0,
    countDown: "",
    showMessage: false,
    messageContent: "",
    showResult: false,
    showPrizeForm:false,
    prizeResult: {
      type: 1,
      title: "一等奖",
      level: "一等奖一等奖"
    }
  },
  mutations: {
    updateState(state) {
      state.initState = 1;
    },
    updateValue(state, payload) {
      const [field, value] = payload;
      state[field] = value;
    },
    updateUser(state, userData) {
      state.userInfo = userData;
      window.localStorage.setItem("userInfo", JSON.stringify(userData));
    },
    updateUserDetail(state, userData) {
      state.userDetail = userData;
      window.localStorage.setItem("userDetail", JSON.stringify(userData));
    },
    updateToast(state, toast) {
      state.toast = toast.status;
      state.toastContent = toast.msg;
      if (toast.time) state.time = toast.time;
    },
    updateCommentNum(state, id) {
      state.num++;
      state.topicId = id;
    },
    updateFormState(state, type) {
      state.showForm = type;
    },
    updateLoginState(state, status) {
      state.login = status;
    },
    updateToken(state, token) {
      state.token = token;
      window.localStorage.setItem("token", token);
    },
    updateRoleState(state, status) {
      state.showRole = status;
    },
    updateViewNum(state, num) {
      state.viewNum = num;
    },
    handleShareState(state, status) {
      state.showShare = status;
    },
    updateVideoCate(state, list) {
      state.videoCates = list;
    },
    updateFloatNavStatus(state, status) {
      state.showFloatNav = status;
    },
    updateJoinState(state, status) {
      state.showJoin = status;
    },
    updateNickState(state, status) {
      state.showNick = status;
    },
    updateMobile(state, bool) {
      state.isMobile = bool;
    },
    updateDomHeight(state, value) {
      state.state = value;
    },
    updateTimeCount(state, value) {
      state.countDown = value;
    },
  },
  // actions: {
  //   async loadVideoCate({commit}){
  //     let data = await getVideoCat();
  //     if(data.code==1) commit("updateVideoCate",[...data.data]);
  //   }
  // },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js